 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTCOVER from '@/components/text/Cover'
 import LOVE_1 from '@/components/love_1'
 import TEXT00A_YOB_AND_JORGENSEN_FM_PROD0 from '@/components/text/00a_Yob_and_Jorgensen_fm_prod0'
 import TEXT00A_YOB_AND_JORGENSEN_FM_PROD0A from '@/components/text/00a_Yob_and_Jorgensen_fm_prod0a'
 import TEXT00A_YOB_AND_JORGENSEN_FM_PROD0B from '@/components/text/00a_Yob_and_Jorgensen_fm_prod0b'
 import TEXT00A_YOB_AND_JORGENSEN_FM_PROD0C from '@/components/text/00a_Yob_and_Jorgensen_fm_prod0c'
 import TEXT00A_YOB_AND_JORGENSEN_FM_PROD0D from '@/components/text/00a_Yob_and_Jorgensen_fm_prod0d'
 import TEXT00A_YOB_AND_JORGENSEN_FM_PROD0E from '@/components/text/00a_Yob_and_Jorgensen_fm_prod0e'
 import TEXT00B_YOB_AND_JORGENSEN_INTRODUCTION_PROD from '@/components/text/00b_Yob_and_Jorgensen_introduction_prod'
 import TEXTPART01 from '@/components/text/Part01'
 import TEXT01_YOB_AND_JORGENSEN_CH1_PROD from '@/components/text/01_Yob_and_Jorgensen_ch1_prod'
 import TEXT02_YOB_AND_JORGENSEN_CH2_PROD from '@/components/text/02_Yob_and_Jorgensen_ch2_prod'
 import TEXT03_YOB_AND_JORGENSEN_CH3_PROD from '@/components/text/03_Yob_and_Jorgensen_ch3_prod'
 import TEXT04_YOB_AND_JORGENSEN_CH4_PROD from '@/components/text/04_Yob_and_Jorgensen_ch4_prod'
 import TEXT05_YOB_AND_JORGENSEN_CH5_PROD from '@/components/text/05_Yob_and_Jorgensen_ch5_prod'
 import TEXTPART02 from '@/components/text/Part02'
 import TEXT06_YOB_AND_JORGENSEN_CH6_PROD from '@/components/text/06_Yob_and_Jorgensen_ch6_prod'
 import TEXT07_YOB_AND_JORGENSEN_CH7_PROD from '@/components/text/07_Yob_and_Jorgensen_ch7_prod'
 import TEXT08_YOB_AND_JORGENSEN_CH8_PROD from '@/components/text/08_Yob_and_Jorgensen_ch8_prod'
 import TEXT09_YOB_AND_JORGENSEN_CH9_PROD from '@/components/text/09_Yob_and_Jorgensen_ch9_prod'
 import TEXTPART03 from '@/components/text/Part03'
 import TEXT10_YOB_AND_JORGENSEN_CH10_PROD from '@/components/text/10_Yob_and_Jorgensen_ch10_prod'
 import TEXT11_YOB_AND_JORGENSEN_CH11_PROD from '@/components/text/11_Yob_and_Jorgensen_ch11_prod'
 import TEXT12_YOB_AND_JORGENSEN_CH12_PROD from '@/components/text/12_Yob_and_Jorgensen_ch12_prod'
 import TEXT13_YOB_AND_JORGENSEN_CH13_PROD from '@/components/text/13_Yob_and_Jorgensen_ch13_prod'
 import TEXT14_YOB_AND_JORGENSEN_CH14_PROD from '@/components/text/14_Yob_and_Jorgensen_ch14_prod'
 import TEXTPART04 from '@/components/text/Part04'
 import TEXT15_YOB_AND_JORGENSEN_CH15_PROD from '@/components/text/15_Yob_and_Jorgensen_ch15_prod'
 import TEXT16_YOB_AND_JORGENSEN_CH16_PROD from '@/components/text/16_Yob_and_Jorgensen_ch16_prod'
 import TEXT17_YOB_AND_JORGENSEN_CH17_PROD from '@/components/text/17_Yob_and_Jorgensen_ch17_prod'
 import TEXT18_YOB_AND_JORGENSEN_CH18_PROD from '@/components/text/18_Yob_and_Jorgensen_ch18_prod'
 import LOVE_2 from '@/components/love_2'
 import TEXT19_YOB_AND_JORGENSEN_CONCLUSION_PROD from '@/components/text/19_Yob_and_Jorgensen_conclusion_prod'
 import TEXT20_INDEX from '@/components/text/20_Index'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/text/Cover",
 			"name" : "text/Cover",
 			"component" : TEXTCOVER
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/text/00a_Yob_and_Jorgensen_fm_prod0",
 			"name" : "text/00a_Yob_and_Jorgensen_fm_prod0",
 			"component" : TEXT00A_YOB_AND_JORGENSEN_FM_PROD0
 		},
 		{
 			"path" : "/text/00a_Yob_and_Jorgensen_fm_prod0a",
 			"name" : "text/00a_Yob_and_Jorgensen_fm_prod0a",
 			"component" : TEXT00A_YOB_AND_JORGENSEN_FM_PROD0A
 		},
 		{
 			"path" : "/text/00a_Yob_and_Jorgensen_fm_prod0b",
 			"name" : "text/00a_Yob_and_Jorgensen_fm_prod0b",
 			"component" : TEXT00A_YOB_AND_JORGENSEN_FM_PROD0B
 		},
 		{
 			"path" : "/text/00a_Yob_and_Jorgensen_fm_prod0c",
 			"name" : "text/00a_Yob_and_Jorgensen_fm_prod0c",
 			"component" : TEXT00A_YOB_AND_JORGENSEN_FM_PROD0C
 		},
 		{
 			"path" : "/text/00a_Yob_and_Jorgensen_fm_prod0d",
 			"name" : "text/00a_Yob_and_Jorgensen_fm_prod0d",
 			"component" : TEXT00A_YOB_AND_JORGENSEN_FM_PROD0D
 		},
 		{
 			"path" : "/text/00a_Yob_and_Jorgensen_fm_prod0e",
 			"name" : "text/00a_Yob_and_Jorgensen_fm_prod0e",
 			"component" : TEXT00A_YOB_AND_JORGENSEN_FM_PROD0E
 		},
 		{
 			"path" : "/text/00b_Yob_and_Jorgensen_introduction_prod",
 			"name" : "text/00b_Yob_and_Jorgensen_introduction_prod",
 			"component" : TEXT00B_YOB_AND_JORGENSEN_INTRODUCTION_PROD
 		},
 		{
 			"path" : "/text/Part01",
 			"name" : "text/Part01",
 			"component" : TEXTPART01
 		},
 		{
 			"path" : "/text/01_Yob_and_Jorgensen_ch1_prod",
 			"name" : "text/01_Yob_and_Jorgensen_ch1_prod",
 			"component" : TEXT01_YOB_AND_JORGENSEN_CH1_PROD
 		},
 		{
 			"path" : "/text/02_Yob_and_Jorgensen_ch2_prod",
 			"name" : "text/02_Yob_and_Jorgensen_ch2_prod",
 			"component" : TEXT02_YOB_AND_JORGENSEN_CH2_PROD
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js